import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klpkonsern/routing';
import { getRequiredConfig } from '@klpkonsern/appconfig';
import type { Bruker } from '@klp/user';
export const EconomyKeyFiguresModuleName = 'economykeyfigures';

export const EconomyKeyFiguresRoutes = {
    moduleRoute: () => generateRoute([EconomyKeyFiguresModuleName]),
};

export const EconomyKeyFiguresAccess = (user?: Bruker): boolean =>
    Boolean(user && user.isAdmin);

export const EconomyKeyFiguresMenuItems = [
    new SidebarMenuItem({
        route: EconomyKeyFiguresRoutes.moduleRoute(),
        matchRoute: EconomyKeyFiguresRoutes.moduleRoute(),
        icon: IconName.PIGGY_BANK,
        translation: 'keyfigures.economyTitle',
        access: EconomyKeyFiguresAccess,
    }),
];

export const PowerBiEconomyKeyFiguresURL = () =>
    getRequiredConfig('WEBAPP_POWER_BI_ECONOMY_KEY_FIGURES_URL');
